import * as React from "react";
import { SmartApplyTemplate } from "../../../template/smart-apply/default-template";
import { SmartApplyR } from "../route";
import { useParams } from "react-router";
import { connectPageService } from "@graffer-inc/smart-apply";
import { useEffect } from "react";
import {
  ApplicationTaskContextProps,
  ApplicationTaskService,
} from "../../../../application/service/smart-apply/application-task-detail/application-task-detail-service";
import { Link } from "react-router-dom";
import {
  ApplicationTask,
  toErrorMessage,
} from "../../../../application/domain/application/application-task";
import { ContentsHeader, PrimaryButton } from "@graffer-inc/console-design-kit";
import { convertToFormattedId } from "@graffer-inc/cloud-gov-core";
import { formatDatetime } from "../../../../utils/date-utils";
import { matchType } from "../../../../application/domain/base/base-type";
import classNames from "classnames";
import { SmartApplyMenuList } from "../../../organisms/smart-apply/menu-list";
import "./application-task-detail.scss";

export const ApplicationTaskDetail: React.FC<ApplicationTaskContextProps> = ({
  isLoading,
  task,
  onLoad,
}) => {
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    onLoad(id);
  }, [onLoad, id]);

  if (!task || isLoading) {
    return null;
  }
  return (
    <SmartApplyTemplate
      breadcrumbs={[]}
      contentsHeader={
        <ContentsHeader
          title={matchType(task.taskType, {
            BulkIssuePdfFile: "交付物ファイルの処理状況",
            BulkUpdateTenantProcessResult: "管理情報入力の処理状況",
          })}
          border={false}
        ></ContentsHeader>
      }
      menuList={<SmartApplyMenuList />}
    >
      <div className={classNames("mb-6")}>
        <div className="field">
          <label className="label">処理ステータス</label>
          <ProgressingStatus task={task} onLoad={() => onLoad(id)} />
        </div>
        <div className="field">
          <label className="label">処理開始日時</label>
          <p>{formatDatetime(task.createdAt)}</p>
        </div>
        <div className="field">
          <label className="label">処理実行ユーザー</label>
          <p>{task.userName}</p>
        </div>
      </div>
      <h2 className={"application-task-detail-h2"}>処理詳細</h2>
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th>申請</th>
            <th>処理状況</th>
            <th>詳細</th>
          </tr>
        </thead>
        <tbody>
          {task.taskDetails &&
            task.taskDetails.map((t) => (
              <tr key={t.applicationId} className="c-tr-has-tag">
                <td>
                  <Link
                    to={SmartApplyR.ApplicationDetail.link({
                      id: t.applicationId,
                    })}
                    className={classNames({
                      "has-text-grey": t.taskStatus === "NotYet",
                    })}
                  >
                    {convertToFormattedId(t.applicationId)}
                  </Link>
                </td>
                <td>
                  {matchType(t.taskStatus, {
                    NotYet: <span>処理中</span>,
                    Success: <span>処理完了</span>,
                    Fail: <span className="has-text-danger">エラー</span>,
                  })}
                </td>
                <td>{t.errCode ? toErrorMessage(t.errCode) : ""}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </SmartApplyTemplate>
  );
};

const ProgressingStatus: React.FC<{
  task: ApplicationTask;
  onLoad: () => void;
}> = ({ task, onLoad }) => {
  if (task.taskDetails.some((t) => t.taskStatus === "NotYet")) {
    return (
      <>
        <p>処理中</p>
        <PrimaryButton text="処理状況を更新する" onClick={onLoad} />
        <p className="help has-text-grey">
          件数が多い場合には、処理に時間がかかります。
        </p>
      </>
    );
  }
  const successCounts = task.taskDetails.filter(
    (t) => t.taskStatus === "Success",
  ).length;
  const failureCounts = task.taskDetails.filter(
    (t) => t.taskStatus === "Fail",
  ).length;
  if (failureCounts > 0) {
    return (
      <p>
        処理完了{successCounts}件 エラー{failureCounts}件
      </p>
    );
  }
  return <p>全件成功</p>;
};

export const ApplicationTaskDetailContainer = connectPageService(
  ApplicationTaskDetail,
  () => new ApplicationTaskService(),
);
